import { TCabinetEntity } from "../graphql/schema";

export const DEFAULT_MAP_ZOOM_LEVEL = 13;

export enum eDeviceState {
  ERROR = 0,
  NORMAL = 1,
  LIGHT_ON = 2,
  SAVING_ENERGY = 3,
}

export enum eUserRole {
  SUPPERADMIN = 1,
  ADMIN = 2,
  GUESS = 3,
}

export enum UserPermissionField {
  LOGIN = "LOGIN",
  TRACKING = "TRACKING",
  USER = "USER",
}

export type TPageTitleValue = {
  page: keyof typeof UserPermissionField;
  title: string;
  link: string;
};

export enum ePageLink {
  LOGIN = "/login",
  TRACKING = "/tracking",
  USER = "/user",
}

export type TPageTitle = {
  [key in ePageLink]: TPageTitleValue;
};

export const PAGE_TITLE: TPageTitle = {
  [ePageLink.LOGIN]: {
    page: UserPermissionField.LOGIN,
    title: "Đăng nhập",
    link: "/login",
  },
  [ePageLink.TRACKING]: {
    page: UserPermissionField.TRACKING,
    title: "Theo dõi",
    link: "/tracking",
  },
  [ePageLink.USER]: {
    page: UserPermissionField.USER,
    title: "Người dùng",
    link: "/user",
  },
};

export type TRoutePage = {
  path: string;
  element: React.FC;
  map: React.FC;
};

export const TOKEN_ASYNC_STORAGE = '@nisse_cabinet_access_token';
export const USER_INFO_ASYNC_STORAGE = '@nisse_user_info';
export const DEFAULT_MAP_CENTER: [number, number] = [10.833177063528913, 106.73188958159712]
export const LOGIN_BG_IMAGE = '/LoginPage.png'
export const LOGO_IMAGE = '/Logo.png'
export const LOGO_BLACK_IMAGE = '/LogoBlack.png'
export const LOGIN_PHONE_TITLE = 'Đăng nhập'
export const LOGIN_PHONE_SUBTITLE = 'Vui lòng nhập số điện thoại để tiếp tục'
export const LOGIN_WRONG_PHONE_ERROR_TEXT = 'Số điện thoại này chưa đúng hoặc chưa có trên hệ thống. Vui lòng kiểm tra và nhập lại.'
export const LOGIN_PHONE_NUMBER_TITLE = 'Số điện thoại'
export const LOGIN_WRONG_PASSWORD_ERROR_TEXT = 'Mật khẩu không chính xác. Vui lòng kiểm tra và nhập lại.'
export const LOGIN_PASSWORD_TITLE = 'Mật khẩu'
export const CREATE_PASSWORD_TITLE = 'Tạo mật khẩu'
export const CREATE_PASSWORD_SUBTITLE = 'Vui lòng tạo một mật khẩu mới'
export const CREATE_PASSWORD_LABEL = 'Mật khẩu'
export const CREATE_CONFIRM_PASSWORD_LABEL = 'Nhập lại mật khẩu'
export const PW_CHECK_MIN_LENGTH_TEXT = 'Mật khẩu cần có 8 ký tự trở lên.'
export const PW_CHECK_MIN_LENGTH = 8
export const PW_CHECK_CAPITAL_TEXT = 'Mật khẩu cần có ít nhất một chữ cái viết hoa.'
export const PW_CHECK_NUMBER_TEXT = 'Mật khẩu cần có ít nhất một chữ số.'
export const PW_CHECK_SPECIAL_CHAR_TEXT = 'Mật khẩu cần có ít nhất một ký tự đặc biệt.'
// eslint-disable-next-line no-useless-escape
export const SPECIAL_CHARACTERS = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
export const CONFIRM_NOT_MATCH_PW_TEXT = 'Mật khẩu không trùng khớp. Vui lòng kiểm tra và nhập lại.'
export const CONFIRM_OTA_TITLE = 'Xác thực OTP'
export const CONFIRM_OTA_SUBTITLE = 'Vui lòng nhập mã OTP vừa được gửi đến số điện thoại '
export const TEST_PHONE_NUMBER = "0964199041"
export const OTP_MAX_LENGTH = 6
export const SECS = 1000
export const VN_PHONE = "+84"
export const PHONE_NUMBER_LEN = 10
export const OTP_TIMEOUT = 2
export const WRONG_OTP_TEXT = "Mã OTP chưa đúng. Vui lòng kiểm tra và nhập lại."
export const SET_USER_INFO_TITLE = 'Thông tin tài khoản'
export const SET_USER_INFO_SUBTITLE = 'Vui lòng nhập thông tin được yêu cầu bên dưới'
export const USER_NAME_TITLE = 'Họ & Tên'
export const USER_POSITION_TITLE = 'Chức vụ'
export const USER_INFO_ERROR_TEXT = "* Thông tin chưa hợp lệ. Vui lòng kiểm tra và nhập lại."

export const DEFAULT_CENTER = [10.734273430510093, 106.64120219665288]
// export const DEFAULT_CENTER = [10.8071667, 106.817833]
// export const DEFAULT_CENTER = [10.832983300045655, 106.76935747605371]

// Fake cabinet entities for development/testing
export const FAKE_CABINET_ENTITIES: TCabinetEntity[] = [
  {
    id: 1,
    hwVersion: "1.0",
    fwVersion: "1.0",
    appKey: "appkey-1"
  },
  {
    id: 2,
    hwVersion: "1.1",
    fwVersion: "1.1",
    appKey: "appkey-2"
  },
  {
    id: 3,
    hwVersion: "1.2",
    fwVersion: "1.2",
    appKey: "appkey-3"
  },
  {
    id: 4,
    hwVersion: "1.3",
    fwVersion: "1.3",
    appKey: "appkey-4"
  }
];

export const FAKE_CABINET_IDENTIFIER = "T000.0"
export const FAKE_CABINET_NAME = "Tủ "
export const FAKE_CABINET_ADDRESS = "123 Đường ABC, Quận XYZ, TP. HCM"
export const FAKE_CABINET_PE_NUMBER = "PE1234567890"

export enum eBranch {
  BR1 = 1,
  BR2 = 2,
}

// Fake schedule data for light dimming
export interface ISchedule {
  time: string;
  value: number;
}

export const FAKE_SCHEDULE_DATA: ISchedule[] = [
  {
    time: "17:30",
    value: 100
  },
  {
    time: "20:15", 
    value: 70
  },
  {
    time: "23:00",
    value: 30
  },
  {
    time: "01:45",
    value: 90
  },
  {
    time: "04:10",
    value: 0
  }
];